export default __webpack_public_path__ + "static/media/bracket_omegaveer_3x_tbs_ketel_isolatie.fe77a0a0.png";